export const locale = {
    lang: 'ru',
    data: {
        'VIEW_SETTINGS': {
            'NAVIGATION': 'Навигация:',
            'TOP': 'Сверху',
            'LEFT': 'Слева',
            'RIGHT': 'Справа',
            'NAV_FOLD_TITLE': 'Свёртывание навигации (в вертикальном режиме):',
            'NAV_FOLD': 'Свернута',
            'TOOLBAR': 'Панель инструментов:',
            'BELOW': 'В контейнере',
            'ABOVE': 'Поверх',
            'LAYOUT_MODE': 'Режим отображения:',
            'BOXED': 'Компактный',
            'FULL_WIDTH': 'На всю ширину',
            'COLORS': 'Цвета:',
            'TOOL_BAR_COLOR': 'Цвет панели инструментов',
            'NAV_BAR_COLOR': 'Цвет панели навигации',
            'ROUTER_ANIMATION': 'Анимация навигации:'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/theme-options/i18n/ru.ts